<template>
    <WH_HandoverPendencyReport-component>
        <div class="mt-5">
            <div class="mt-5">
                <div class="mt-5"> 
                    <b-row class="mt-5">
                        <b-col md="3">
                            <b-form-group label="From Date:"  :label-cols="4" >
                                <v-date-picker mode='single' 
                                    input-class="dateInput" :available-dates='{ start: null, end: new Date() }' v-model='selectDateFrom'>
                            </v-date-picker>
                            </b-form-group>
                        </b-col>
                
                        <b-col md="3">
                            <b-form-group label="To Date:"  :label-cols="4" >
                                <v-date-picker mode='single' 
                                    input-class="dateInput" :available-dates='{ start: null, end: new Date() }' v-model='selectDateTo'>
                                </v-date-picker>
                            </b-form-group>
                        </b-col>

                        <b-col md="4">
                            <b-form-group label="Warehouse ID" :label-cols="4">
                                <div id='container'>
                                    <ejs-multiselect  id='multi_select2'  placeholder="Select WareHouse" v-model="valueWH" :dataSource='optionsWH' :showSelectAll='showSelectAll' selectAllText="Select All" unSelectAllText="unSelect All"    :fields='fieldWH' :allowCustomValue='allowCustomValue'  enableGroupCheckBox="true" mode="CheckBox" 
                                ></ejs-multiselect>
                                </div>
                            </b-form-group>
                        </b-col>
                        <b-col md="2">
                            <span @click="Pendencyreport(pendencypageNum)">
                                <b-button  @click="hanoverpendency_deatils(pageNum)" size="md" variant="primary">Search</b-button>&nbsp;&nbsp;
                            </span>
                            <b-button  @click="clearSearch()" size="md" variant="danger">Clear</b-button>&nbsp;
                        </b-col>
                    </b-row>
                </div>
                
                <b-col sm="12" class="text-right">
                    <p> <b>Total Records :<span style="color:red;"> {{whtotalRows}}</span></b> </p>
                </b-col>

                <b-col>
                    <table class="table  table-bordered">
                        <thead>
                        <tr>
                            <th scope="col"></th>
                            <th colspan="10" class="text-center">Gap Days</th>
                            <th scope="col"></th>
                        </tr>
                        </thead>
                        <thead>
                            <tr>
                            <th>Hub Name</th>
                            <th class="text-center">0</th>
                            <th class="text-center">1</th>
                            <th class="text-center">2</th>
                            <th class="text-center">3</th>
                            <th class="text-center">4</th>
                            <th class="text-center">5-9</th>
                            <th class="text-center">10</th>
                            <th class="text-center">11-20</th>
                            <th class="text-center">21-30</th>
                            <th class="text-center">31-60</th>
                            <th class="text-center">Total</th>
                            </tr>
                        </thead>
                        <thead>
                            <tr>
                                <th>Total</th>
                                <th class="text-center">{{ columnTotal(1) }}</th>
                                <th class="text-center">{{ columnTotal(0) }}</th>
                                <th class="text-center">{{ columnTotal(2) }}</th>
                                <th class="text-center">{{ columnTotal(3) }}</th>
                                <th class="text-center">{{ columnTotal(4) }}</th>
                                <th class="text-center">{{ columnTotal('5-9') }}</th>
                                <th class="text-center">{{ columnTotal(10) }}</th>
                                <th class="text-center">{{ columnTotal('11-20') }}</th>
                                <th class="text-center">{{ columnTotal('21-30') }}</th>
                                <th class="text-center">{{ columnTotal('31-60') }}</th>
                                <th class="text-center">{{sumAllPosition}}</th>
                            </tr>
                        </thead>
                        <tbody v-if="whtotalRows > 0">
                        <tr v-for="(value,key) in whGapdays" :key="key">
                            <th scope="row">{{key}}</th>
                            <td class="text-center">{{value[0]}}</td>
                            <td class="text-center">{{value[1]}}</td>
                            <td class="text-center">{{value[2]}}</td>
                            <td class="text-center">{{value[3]}}</td>
                            <td class="text-center">{{value[4]}}</td>
                            <td class="text-center">{{value['5-9']}}</td>
                            <td class="text-center">{{value[10]}}</td>
                            <td class="text-center">{{value['11-20']}}</td>
                            <td class="text-center">{{value['21-30']}}</td>
                            <td class="text-center">{{value['31-60']}}</td>
                            <td class="text-center">{{ totalWHGapdays[key]==null?0:totalWHGapdays[key]}}</td>
                        </tr>
                        </tbody>
                        <tbody v-else>
                            <tr>
                                <td colspan="12"><b>No Records Found</b></td>
                            </tr>
                        </tbody>
                    </table>
                </b-col>

                <b-col sm="12" class="text-right">
                    <a :href="loadreportPendencyurl" target="_blank">
                    <b-button variant="primary" @click="downloadcsvreport()" v-if="totalRows>0">Download</b-button></a><br><br>
                    <p> <b>Total Records :<span style="color:red;"> {{totalRows}}</span></b> </p>
                </b-col>
                
                <b-table show-empty responsive  :items="items"  :fields="fields"  :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"    @filtered="onFiltered"    :outlined="outlined" :busy="isBusy" >
                    <div slot="table-busy" class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                    </div> 
                </b-table>

                <b-row>
                    <b-col sm="12">
                    <paginate :page-count="noofpages" :page-range="10"
                    :margin-pages="2" :click-handler="clickCallback"
                    :prev-text="'Prev'" :next-text="'Next'" :container-class="'pagination'"
                    :page-class="'page-item'"></paginate>
                    </b-col>
                </b-row>
            </div>
        </div>    
    </WH_HandoverPendencyReport-component>
</template>


<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import auth from '@/utils/auth'

export default {
    data() {
        return {
            selectDateFrom: new Date(),
            selectDateTo:new Date(),
            valueWH:[],
            fieldWH:{ text: 'name', value: 'id' },
            optionsWH:[],
            WHData:[],
            showSelectAll : true,
            isBusy : false,
            sortBy: null,
            sortDesc: false,
            sortDirection: 'asc',
            filter: null,
            items :[],
            fields: [
                { key: 'warehouseid', label: 'Warehouse ID', sortable: true, sortDirection: 'desc' },
                { key: 'custvendorname', label: 'Warehouse Name', sortable: true, sortDirection: 'desc' },
                { key: 'loadid', label: 'Load ID', sortable: true, sortDirection: 'desc' },
                { key: 'accounttype', label: 'Account Type',sortable: true, sortDirection: 'desc' },
                { key: 'awb', label:'AWB', sortable: true, sortDirection: 'desc' },
                { key: 'totalboxcount', label: 'Total Box Count', sortable: true,sortDirection: 'desc'},
                { key: 'whdispatchboxcount', label: 'WH Dispatch Box count', sortable: true, sortDirection: 'desc'},
                { key: 'gapdays', label: 'Gap Days', sortable: true, sortDirection: 'desc'},
                { key: 'gaphours', label: 'Gap Hours', sortable: true, sortDirection: 'desc' },
                { key: 'whdispatchdate', label: 'WH Dispatch Date', sortable: true,sortDirection: 'desc' },
                { key: 'invoiceamount', label: 'Invoice Amount', sortable: true, sortDirection: 'desc'},
                { key: 'rbstatus', label: 'RB Status', sortable: true, sortDirection: 'desc'},
                { key: 'hubinscanpendingboxcount', label: 'RB HubInscan Pending Box Count', sortable: true, sortDirection: 'desc'},
            ],
            totalRows :0,
            noofpages:'',
            pageNum:1,
            loadreportPendencyurl :'',

            //gap days//
            pendencypageNum :1,
            // whpageNum:1,
            // whnoofpages :'',
            whtotalRows :0,
            WH_penitems :[],
            totalWHGapdays :[],
            whGapdays :[],

        }
    },

    created() {
        let userData = localStorage.getItem('userData');
        let userInfo = JSON.parse(userData);
         this.showWHlist()
        this.hanoverpendency_deatils(this.pageNum);
        this.Pendencyreport(this.pendencypageNum)
    },

    computed: {
        // columnTotal() {
        //     return (position) => {
        //         return Object.values(this.whGapdays).reduce((sum, value) => sum + (value[position] || 0), 0);
        //     };
        // },
        // sumAllPosition() {
        //     return Object.values(this.totalWHGapdays).reduce((sum, value) => sum + value, 0);
        // }
        columnTotal() {
            return (position) => {
                return Object.values(this.whGapdays).reduce((sum, value) => sum + (parseInt(value[position]) || 0), 0);
            };
        },
        sumAllPosition() {
            
            return Object.values(this.totalWHGapdays).reduce((sum, value) => sum + parseInt(value), 0);
        }
        // Add other computed properties for additional sums if needed
    },

    methods: {

        showWHlist:function(){
          
            var userdata = localStorage.getItem('userData')
            var userInfo = JSON.parse(userdata)
            
            var csvObj = {};
            
            
            this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getWarehouselistingforHandoverReport`, csvObj)
            .then(result => {
                
                if (result.body.returnmsg === 'Successful') {
                    this.optionsWH=[];
                
                    this.WHData  = result.body.returnvalue;
                
                    for(let j = 0; j < this.WHData.length; j++) {
                        let WH = {
                            name: this.WHData[j].warehousename ,
                            // + " - " + this.WHData[j].warehouseid
                            id: this.WHData[j].warehouseid,
                        }
                        this.optionsWH.push(WH);
                        // this.options_reportWH.push(WH)
                    }
                
                } 
                else {
                    this.WHData  = result.body.returnvalue;
                }
                    
        
            })
            .catch(ex => {
                console.log("error-----", ex);
            });
        },

        clickCallback (pendencypageNum){
            this.Pendencyreport(pendencypageNum);
        },

        Pendencyreport(pageNo){
            this.WH_penitems = [];
            this.totalWHGapdays = [];
            this.whGapdays = [];
            this.whtotalRows= 0;

            var userdata = localStorage.getItem('userData')
            var userInfo = JSON.parse(userdata)

            var fromdate = (this.selectDateFrom!=null)?this.formatDate(this.selectDateFrom):"";
            var formatdateto=(this.selectDateTo!=null)? this.formatDate(this.selectDateTo):"";
    
            var Obj = {
                page_no:`${pageNo}`,
                startdate : fromdate,
                enddate : formatdateto,
                warehouseid : this.valueWH.length==0?'':this.valueWH
            };
          
          
            this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/gethandoverpendencyreport`, Obj)
            .then(result => {
                if (result.body.returnmsg === 'successful') {
                    this.WH_penitems = result.body.returnvalue;
                    this.totalWHGapdays = result.body.totalWHGapdays;
                    this.whGapdays = result.body.whGapdays;
                    this.whtotalRows= result.body.totalcount;
                    this.noofpages=parseInt(this.whtotalRows)/20;
                    this.noofpages=Math.ceil( this.noofpages);
                
                } 
                else {
                    this.items  = [];
                    this.totalRows =0;
                }
                    
        
            })
            .catch(ex => {
                console.log("error-----", ex);
            });
        },

        clickCallback (pageNum){
            this.hanoverpendency_deatils(pageNum);
        },

        hanoverpendency_deatils(pageNo){
            this.isBusy = true;
            var userdata = localStorage.getItem('userData')
            var userInfo = JSON.parse(userdata)

            var fromdate = (this.selectDateFrom!=null)?this.formatDate(this.selectDateFrom):"";
            var formatdateto=(this.selectDateTo!=null)? this.formatDate(this.selectDateTo):"";
    
            var Obj = {
                page_no:`${pageNo}`,
                startdate : fromdate,
                enddate : formatdateto,
                warehouseid : this.valueWH.length==0?'':this.valueWH
            };
          
          
            this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getwarehousehandovershipments`, Obj)
            .then(result => {
                this.isBusy = false;
                if (result.body.returnmsg === 'successful') {
                    this.items = result.body.returnvalue;
                    this.totalRows= result.body.totalcount;
                    this.noofpages=parseInt(this.totalRows)/20;
                    this.noofpages=Math.ceil( this.noofpages);
                
                } 
                else {
                    this.items  = [];
                    this.totalRows =0;
                }
                    
        
            })
            .catch(ex => {
                console.log("error-----", ex);
            });
        },

        clearSearch(){
            this.selectDateFrom = new Date();
            this.selectDateTo = new Date();
            this.valueWH =[];
            this.hanoverpendency_deatils(this.pageNum);
            this.Pendencyreport(this.pendencypageNum)
        },

        downloadcsvreport(){
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);

            var fromdate = (this.selectDateFrom!=null)?this.formatDate(this.selectDateFrom):"";
            var formatdateto=(this.selectDateTo!=null)? this.formatDate(this.selectDateTo):"";

            this.loadreportPendencyurl=`${CONSTANTS.MIGRATION_API_URL}/getwarehousehandovershipmentscsv?startdate=`+fromdate+`&enddate=`+formatdateto+`&warehouseid=`+(this.valueWH.length==0?'':this.valueWH)
            console.log("this.loadreportPendencyurl",this.loadreportPendencyurl)
        },


        formatDate: function(date) {
            var d = new Date(date),
                month = "" + (d.getMonth() + 1),
                day = "" + d.getDate(),
                year = d.getFullYear();
            if (month.length < 2) month = "0" + month;
            if (day.length < 2) day = "0" + day;
            return [year, month, day].join("-");

        },
    },
}
</script>